module.exports = __webpack_public_path__ + "static/media/Workday_Step2a_Image5m.96b28357.jpg";